import { render, staticRenderFns } from "./BatchJobDetail.vue?vue&type=template&id=5cef933e&scoped=true&"
import script from "./BatchJobDetail.vue?vue&type=script&lang=js&"
export * from "./BatchJobDetail.vue?vue&type=script&lang=js&"
import style0 from "./BatchJobDetail.vue?vue&type=style&index=0&id=5cef933e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef933e",
  null
  
)

export default component.exports